'use client';

import React, { useState } from 'react';
import Filters from '../others/Filters';
import CatalogueTable from '../others/CatalogueTable';
import { AdminCatalogueView, SelectedSample } from '../Catalogue';

export type visibilityType = '' | 'public' | 'restricted' | 'hidden';

export interface CatalogueFilters {
  search: string;
  visibility: visibilityType;
  group: string;
}

interface ICatalogueTableView {
  setView: React.Dispatch<React.SetStateAction<AdminCatalogueView>>;
  selectedSamples: SelectedSample[];
  setSelectedSamples: React.Dispatch<React.SetStateAction<SelectedSample[]>>;
}

const CatalogueTableView = ({ setView, selectedSamples, setSelectedSamples }: ICatalogueTableView) => {
  const [filters, setFilters] = useState<CatalogueFilters>({
    search: '',
    visibility: '',
    group: '',
  });
  const [page, setPage] = useState(1);

  const handleFilterChange = (key: keyof CatalogueFilters, value: string) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
    setPage(1); // Reset to first page when filters change
  };

  return (
    <div className="flex flex-col h-full">
      <Filters filters={filters} onFilterChange={handleFilterChange} />
      <div className="flex-1 min-h-0">
        <CatalogueTable
          filters={filters}
          page={page}
          onPageChange={setPage}
          selectedSamples={selectedSamples}
          onSelectionChange={setSelectedSamples}
          setView={setView}
        />
      </div>
    </div>
  );
};

export default CatalogueTableView;
